export const MAX_BULK_CONTACTS_DELETE_SIZE = 5
export const MAX_MERGE_CONTACTS_SIZE = 2
